export function cn(...values: Array<string | false | null | undefined>) {
  return values.filter(Boolean).join(" ");
}

export function formatNumber(value: number) {
  return new Intl.NumberFormat("en-US").format(value);
}

export function difficultyClass(difficulty: string) {
  return `difficulty difficulty-${difficulty.toLowerCase()}`;
}

/** Visual treatment for a problem's completion status (solved / attempted / todo). */
export function statusMeta(status: string) {
  switch (status) {
    case "solved":
      return { label: "Solved", dot: "bg-green text-white", ring: "border-green/40" };
    case "attempted":
      return { label: "Attempted", dot: "bg-lime text-ink", ring: "border-[#aef58c]" };
    default:
      return { label: "Not started", dot: "bg-wash text-muted", ring: "border-line" };
  }
}

export const siteUrl = "https://targetqa.com";
